export const demoPortal = new URLSearchParams(location.search).get("demo") === "1";
export function portalApiPath(path: string) {
  if (!demoPortal) return path;
  if (path === "/portal/api/access/exchange") return "/api/demo/supplier-access/exchange";
  return path.startsWith("/portal/api/") ? `/api/demo/supplier-portal/${path.slice("/portal/api/".length)}` : path;
}
async function responseBody(response: Response, fallback: string): Promise<unknown> {
  const body: unknown = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = typeof body === "object" && body !== null && "message" in body && typeof body.message === "string" ? body.message : fallback;
    throw new Error(message);
  }
  return body;
}
export async function portalRequest(path: string, init?: RequestInit) {
  return responseBody(await fetch(portalApiPath(path), {
    credentials: "include", ...init,
    headers: { "content-type": "application/json", ...(demoPortal ? { "x-demo-role": "SATIN_ALMA" } : {}), ...(init?.headers ?? {}) },
  }), "İşlem tamamlanamadı.");
}
export async function uploadPortalDocument(file: File) {
  const form = new FormData();
  form.append("file", file);
  return responseBody(await fetch("/portal/api/documents", {
    method: "POST", credentials: "include", headers: { "idempotency-key": crypto.randomUUID() }, body: form,
  }), "Belge yüklenemedi.");
}
